import React from "react"
import PropTypes from "prop-types"
import { Flex, Button } from "antd"
import { useTranslation } from "react-i18next"
import { Text } from "ui/Typography"
import { colors } from "themes/variables"
import { routes } from "router/routes"
import styles from "./index.module.css"

const generateBookingLink = (booking) => {
  const { booking_uuid } = booking || {}

  if (booking_uuid) {
    return `#${routes.guideBookingDetailsPath({ id: booking_uuid })}`
  }

  return "#"
}

const BookingCard = ({ booking }) => {
  const { t } = useTranslation()

  return (
    <Flex vertical gap={8} className={styles.bookingCard}>
      <Flex justify="space-between" align="start">
        <Flex vertical gap={4} className={styles.bookingInfo}>
          <Text weight="semibold" color={colors.textPrimary}>
            {booking.experience_name}
          </Text>
          <Text size="sm" color={colors.textSecondary}>
            <Text as="span" weight="semibold">{t("crewMember.scheduledTimeOff.bookingConflictList.date")}:</Text> {booking.booked_date}
          </Text>
          <Text size="sm" color={colors.textSecondary}>
            <Text as="span" weight="semibold">{t("crewMember.scheduledTimeOff.bookingConflictList.time")}:</Text> {booking.start_time}
          </Text>
          <Text size="sm" color={colors.textSecondary}>
            <Text as="span" weight="semibold">{t("crewMember.scheduledTimeOff.bookingConflictList.client")}:</Text> {booking.client_name}
          </Text>
        </Flex>
        <Button
          type="link"
          href={generateBookingLink(booking)}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.viewButton}
        >
          {t("crewMember.scheduledTimeOff.bookingConflictList.viewDetails")}
        </Button>
      </Flex>
    </Flex>
  )
}

BookingCard.propTypes = {
  booking: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    experience_name: PropTypes.string.isRequired,
    booked_date: PropTypes.string.isRequired,
    start_time: PropTypes.string.isRequired,
    client_name: PropTypes.string.isRequired,
    booking_uuid: PropTypes.string.isRequired
  }).isRequired
}

export default BookingCard
